/*
 *  -----------------------------------------------------------------------
 *    <copyright file="public.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';

const PublicLayout = ({ children }: any) => <div className="public-layout">{children}</div>;

export default PublicLayout;
